import axios from "axios";

const path = "/attributes/";

export const attributesService = {
  async calculateRarity(chainId, address) {
    await axios.post(`${path}calculate-rarity/${address}/${chainId}`);
  },
  async refreshAllMetadata(address) {
    await axios.post(path + "refresh-all-metadata/" + address);
  },
};
